import { css } from '@emotion/react';
export const getCustomDatePickerStyles = (tokens) => css `
  .calendar {
    background-color: ${tokens.Layer01};
  }

  .react-datepicker__time-list {
    min-width: fit-content;
  }

  .react-datepicker__day--selected,
  .react-datepicker__time-list-item--selected {
    background-color: ${tokens.CanvasPrimary}!important;
  }

  .react-datepicker__day--keyboard-selected,
  .react-datepicker__navigation:focus {
    outline: 2px solid ${tokens.BorderFocus};
    outline-offset: 1px;
    background-color: ${tokens.CanvasPrimary200}!important;
  }

  .react-datepicker__time-list-item:focus {
    outline: 2px solid ${tokens.BorderFocus};
    outline-offset: 0;
    background-color: ${tokens.CanvasPrimary200}!important;
    color: ${tokens.TextDark800}!important;
  }

  .react-datepicker__navigation:focus
    > .react-datepicker__navigation-icon:before {
    border-color: ${tokens.CanvasPrimary}!important;
  }

  .react-datepicker__day:hover,
  .react-datepicker__time-list-item:hover {
    background-color: ${tokens.CanvasPrimary300}!important;
  }

  .react-datepicker__day--today {
    background-color: ${tokens.CanvasPrimary400};
  }
`;
